import { getTrans, isNum } from './instantLoaded/tools';
import sessionStore from '@/stores/session';
import firstInit from '@/stores/firstInit';
import { TRANSIFY_KEY, PARTNER_APP_BUSINESS_TRANSIFY_KEYS, FROM, LIVE_LEAVE_MSG_BTN, LIVE_OFFLINE_FORM_PAGE } from '@/utils/constants';
import { DIALOGUE_FROM, DIALOGUE_TYPE } from '@/types/common';
import { getConfig } from '@/config/core';

// 更新某条dialogue中的data信息（通过index）
export const updateDialogueInfo = (dialogue, index) => {
  isNum(index) && sessionStore.UPDATE_DIALOGUE({
    obj: dialogue,
    index,
  });
};

// 更新 initList 某条 dialogue 中的 data 信息（通过type）
export const updateInitListDialogueInfo = (type, data) => {
  sessionStore.UPDATE_INIT_LIST_DIALOGUE(type, data);
};

// 更新某条dialogue外层数据，非data中的数据
export const updateDialogueOuterData = (dialogue, index) => {
  isNum(index) && sessionStore.UPDATE_DIALOGUE_OUTER_DATA({
    obj: dialogue,
    index,
  });
};

// 更新某条dialogue的feedback信息（通过index）
export const updateDialogueFeedback = (dialogue, index) => {
  index && sessionStore.UPDATE_DIALOGUE_FEEDBACK({
    obj: dialogue,
    index,
  });
};

// disable全部包含channel option卡片的按钮
export const disableDialogueChannelOptionButton = () => {
  sessionStore.UPDATE_DIALOGUE_WHO_HAS_CHANNEL_OPTION({ disabledBtn: true });
};

// 隐藏全部包含channel option卡片的按钮
export const hideDialogueChannelOptionButton = () => {
  sessionStore.UPDATE_DIALOGUE_WHO_HAS_CHANNEL_OPTION({ isDisabled: true });
};

// 添加一条dialogue
// 返回当前dialogue的index
export const addDialogue = (dialogue, withTyping = true, targetSessionId) => {
  if (Array.isArray(dialogue)) {
    dialogue.forEach((item) => addDialogue(item, withTyping));
  } else {
    // 用户输入：频控
    if (dialogue.from === 'user' && withTyping) {
      // 过快
      if (sessionStore.ifRequestOverfast) {
        // 提示输入过快
        addTip(getTrans('error_too_frequent'));
        // 调用方判断为false说明不该进行下一步动作
        return false;
      } else {
        sessionStore.UPDATE_REQUEST_TIMESTAMP();
        sessionStore.ADD_DIALOGUE(dialogue, withTyping, targetSessionId);
      }
    } else {
      sessionStore.ADD_DIALOGUE(dialogue, withTyping, targetSessionId);
    }
  }
  // 返回当前dialogue位置
  const curPos = sessionStore.getCurPos();
  return curPos;
};

// 添加Tip提示
export const addTip = (content) => {
  content && addDialogue({
    from: 'system',
    type: 'Tip',
    data: { content },
  });
};

// 转人工提示
export const addToLiveTip = () => {
  addDialogue({
    dialogueId: '',
    dialogueType: 'ERROR',
    from: DIALOGUE_FROM.BOT,
    type: DIALOGUE_TYPE.Live,
    data: {
      msgContent: getTrans(TRANSIFY_KEY.MSG_ERROR_TO_LIVE),
      btnContent: getTrans(TRANSIFY_KEY.BTN_LIVE),
    },
  });
};

export const addToLiveOrWebFormTip = () => {
  const showLiveAgent = firstInit.userSwitchShowLiveAgent;
  if (showLiveAgent) {
    addToLiveTip();
  } else {
    const { webFormConfig } = getConfig();
    addDialogue({
      dialogueId: '',
      dialogueType: 'ERROR',
      from: DIALOGUE_FROM.BOT,
      type: DIALOGUE_TYPE.Redirection,
      data: {
        msgContent: getTrans(TRANSIFY_KEY.MSG_ERROR_TO_LIVE),
        buttons: [
          {
            text_key: LIVE_LEAVE_MSG_BTN,
            uri_key: webFormConfig.webFormKey || LIVE_OFFLINE_FORM_PAGE,
            uri_extra: {},
            extraParams: { popSelf: 1 }, // 关闭当前页面
          },
        ],
      },
    });
  }
};

// shopee food新增默认greeting消息
export const addDefaultGreeting = (greeting) => {
  addDialogue({
    dialogueId: '',
    from: 'bot',
    type: 'Live',
    data: { msgContent: greeting || getTrans(TRANSIFY_KEY.SHOPEE_FOOD_DEFAULT_GREETING) },
  });
};

// shopee food新增chat with agent消息
export const addShopeeFoodChatWithAgent = () => {
  addDialogue({
    dialogueId: '',
    from: 'bot',
    type: 'Live',
    data: {
      msgContent: getTrans(TRANSIFY_KEY.LIVECHAT_CHAT_WITH_AGENT_MESSAGE),
      btnContent: getTrans(TRANSIFY_KEY.BTN_LIVE),
    },
  });
};


/**
 * @description 为Partner App下的业务线在一进来的时候添加一条加入Live的消息，点击可以自动进线进行live-chat
 * @param {FROM} from 从哪个entryPoint进来
 * @returns {void}
 */
export const addPartnerChatWithAgent = (from = FROM.MitraPartner) => {
  const transifyConfig = PARTNER_APP_BUSINESS_TRANSIFY_KEYS[from];
  addDialogue({
    dialogueId: '',
    from: 'bot',
    type: DIALOGUE_TYPE.Live,
    data: {
      msgContent: getTrans(transifyConfig?.greeting),
      btnContent: getTrans(transifyConfig?.chatWithAgent),
    },
  });
};
